import { api } from "@/lib/api";
import { toast } from "sonner";

export async function startCheckout({ product, quantity, proxy_account_id, promotion_code }) {
  try {
    const { data } = await api.post("/payments/checkout", {
      product, quantity, proxy_account_id: proxy_account_id || null,
      promotion_code: promotion_code || null,
      origin_url: window.location.origin,
    });
    window.location.href = data.checkout_url;
  } catch (err) {
    const d = err.response?.data?.detail;
    toast.error(typeof d === "string" ? d : "Could not start checkout");
  }
}
